<template>
  <div @click="toggleOpen()" class="chat-start" :class="[ init ? 'init' : '', open_modal ? 'close-status' : '' ] ">
      <div class="all-message-cyc" :class=" ((open_message && all_unread > 0) || (all_unread > 0 && !open_modal)) ? 'ac' : ''">{{ all_unread }}</div>
      <!-- <div class="all-message-cyc ac">10</div> -->
      <div class="open"></div>
      <div id="chat-app-trigger-btn" class="close"></div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState(['init', 'user', 'open_modal', 'open_message']),
        ...mapGetters('chatList', ['all_unread'])
    },
    methods: {
        ...mapMutations(['switchModal']),
        ...mapMutations('chatList', ['showChatLoading']),
        ...mapMutations('messageList', ['updateMessagePage']),
        toggleOpen() {
            this.showChatLoading()
            this.updateMessagePage({ last_page: 0, current_page: 0 })
            if (this.open_message) {
                this.$remote.$emit('getconversations', this.user)
            }
            this.switchModal()
            if (this.user.uuid && this.open_modal) {
                this.$remote.$emit('getconversations', this.user)
            }
        }
    }
}

</script>


<style lang="scss" scoped>
.chat-start { position: relative; width: 60px; height: 60px; background: #286efa; border-radius: 50%; opacity: 0;
    box-shadow: 0 2px 8px rgba(0,0,0,.09),0 4px 40px rgba(0,0,0,.24)!important; transform: scale(0) translateY(-5px); transition: all .3s ease-in-out;
    .open, .close {position: absolute; top: 0; left: 0; bottom: 0; right: 0; transition: all .15s ease-in-out;}
    .open { background: url('../assets/speech-bubble.svg') no-repeat center center; background-size: 32px 36px; transform: scale(1); opacity: 1; background-position: center 14px;}
    .close { background: url('../assets/close_modal.png') no-repeat center center; background-size: 14px 14px; transform: rotate(-90deg) scale(0); opacity: 0;}
    &.init { transform: scale(1) translateY(0); opacity: 1;}
    &.close-status { box-shadow: 0 2px 20px rgba(0,0,0,.09),0 4px 40px rgba(0,0,0,.24)!important;
        .open {transform: scale(0); opacity: 0; transition: all .15s ease-in-out;}
        .close { transform: rotate(0deg) scale(1); opacity: 1; transition: all .25s ease-in-out;}
    }
    .all-message-cyc {display: block; min-width: 20px; height: 20px; background: #f40; color:#fff; font-size: 12px; line-height: 16px;
        opacity: 0; transform: scale(0); text-align: center; border-radius: 10px; border: 2px solid #fff; top: -8px; left: -2px; 
        position: absolute; padding: 0 4px; transition: all .3s ease-in-out;
        &.ac {transform: scale(1); opacity: 1;}
    }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatStart.vue